module.exports = __webpack_public_path__ + "img/item4.4e204418.png";